var ko = require('knockout'),
  APIHelper = require('_js/APIHelper'),
  PAGE_TYPE = require('_js/constants/registration-page-type');

function RegistrationInfoMember(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;
  self.API = params.api;

  self.requiredFields = [];

  self.componentActive = false;
  self.step = params.step;
  self.currentStep = ko.observable(self.parent.currentStep());

  self.inputFields = $('.form-info-member').find(':input');
  self.currentInputField = 0;

  // Determine if this page is the current step.
  self.parent.currentStep.subscribe(function(val) {
    if (val === self.step()) {
      self.activateComponent();
    } else {
      self.deactivateComponent();
    }
  });

  self.showBureauMemberText = ko.observable(false);
  self.isBureauMemberOfRn = ko.observable('false'); // Should convert to boolean?
  self.isBureauMemberOfRn.subscribe(function(value) {
    if (value === 'true') {
      self.showBureauMemberText(true);
    } else {
      self.showBureauMemberText(false);
    }
  });

  self.positionLevelTmp = 0;
  self.positionLevelOptions = ko.observableArray();
  self.positionLevel = ko.observable().extend({
    required: [
      {
        type: 'isPositiveNumber',
        message: self.parent.errorMessages.itemFromListNotChosen
      }
    ]
  });
  self.workTitle = ko.observable();
  self.otherRoles = ko.observable('None');
  self.recruiter = ko.observable().extend({
    required: [
      { type: 'isOptional', message: 'optional' },
      {
        type: 'isNumber',
        message: self.parent.errorMessages.notANumber
      },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsMembershipNumber,
        length: 8
      }
    ]
  });

  self.isStudentOrTrainee = ko.observable('student').extend({
    required: [{ type: 'isNotEmpty', message: 'Feltet kan ikke være tomt' }]
  });

  self.isStudentOrTrainee.subscribe(function(newVal) {
    self.adjustSteps(newVal);
    if (newVal === 'student') {
      if (parseInt(self.studentTraineeLocationId(), 10) === -1) {
        self.requiredFields = [
          self.isStudentOrTrainee,
          self.studentTraineeLocation,
          self.studentTraineeEndDate
        ];
      } else {
        self.requiredFields = [
          self.isStudentOrTrainee,
          self.studentTraineeLocationId,
          self.studentTraineeEndDate
        ];
      }
    } else if (newVal === 'trainee') {
      self.requiredFields = [self.isStudentOrTrainee];
    }
  });

  self.studentTraineeLocation = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.studentTraineeLocationEmpty
      }
    ]
  });
  self.studentLocationTmp = 0;
  self.studentLocations = ko.observableArray();
  self.studentTraineeLocationId = ko.observable().extend({
    required: []
  });

  self.yearArray = ko.observableArray();
  self.studentTraineeEndDateTmp = new Date().getFullYear();
  self.studentTraineeEndDate = ko.observable().extend({
    required: [
      {
        type: 'isNotEmpty',
        message: self.parent.errorMessages.requiredFieldEmpty
      }
    ]
  });

  self.studentMonthAndDay = '-07-01';

  if (self.parent.signuptype === 'studentandpractice') {
    self.adjustSteps(self.isStudentOrTrainee());
    self.studentTraineeLocationId.subscribe(function(val) {
      // If the location is not in registered in our database, we need to
      // require the user to input their school location.
      if (parseInt(val, 10) === -1) {
        self.requiredFields = [
          self.isStudentOrTrainee,
          self.studentTraineeLocation,
          self.studentTraineeEndDate
        ];
      } else {
        self.requiredFields = [
          self.isStudentOrTrainee,
          self.studentTraineeLocationId,
          self.studentTraineeEndDate
        ];
      }
    });
  }

  if (self.parent.signuptype !== 'studentandpractice') {
    self.requiredFields = [self.positionLevel];
  } else {
    self.requiredFields = [self.isStudentOrTrainee, self.studentTraineeEndDate];
  }

  var regData = sessionStorage.getItem('rn-registration');
  if (regData !== undefined && regData !== null) {
    var parsedRegData = JSON.parse(regData);
    if (parsedRegData.infoMember !== undefined) {
      self.populateInputFromStore(parsedRegData.infoMember);
    }
  }
}

RegistrationInfoMember.prototype.init = function(element) {
  this.$element = $(element);
  this.activateComponent();
};

RegistrationInfoMember.prototype.activateComponent = function() {
  var self = this;
  // Since this is called in the constructor we need to do verify that we are at the correct step.
  if (self.step() === self.parent.currentStep()) {
    self.componentActive = true;
    self.parent.addInputControlForPage(self.inputFields);
    self.setPositionLevelList();
    self.setStudentLocations();
    self.setYearArray();
  }
};

RegistrationInfoMember.prototype.deactivateComponent = function() {
  var self = this;
  // If the component is already deactivated we can just exit the function.
  if (!self.componentActive) {
    return;
  }
  // Only deactivate the component if the current step is not this step.
  if (self.step() !== self.parent.currentStep()) {
    self.componentActive = false;
    self.parent.removeInputControlForPage(self.inputFields);
  }
};

RegistrationInfoMember.prototype.adjustSteps = function(val) {
  if (val === 'student') {
    this.parent.steps([
      PAGE_TYPE.PERSONAL_INFO,
      PAGE_TYPE.PERSONAL_STATUS,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
  } else if (val === 'trainee') {
    this.parent.steps([
      PAGE_TYPE.PERSONAL_INFO,
      PAGE_TYPE.PERSONAL_STATUS,
      PAGE_TYPE.EMPLOYER,
      PAGE_TYPE.CONFIRMATION,
      PAGE_TYPE.END
    ]);
  }
  this.parent.steps.valueHasMutated();
};

RegistrationInfoMember.prototype.submitForm = function() {};

RegistrationInfoMember.prototype.setPositionLevelList = function() {
  var self = this,
    url = self.API.getPositionLevelList;
  // Only perform the API call if we haven't already done so.
  if (self.positionLevelOptions().length === 0) {
    APIHelper.get(
      url,
      function(data) {
        self.positionLevelOptions(data);
        // We can set the stored positionLevel after the options have been set.
        self.positionLevel(self.positionLevelTmp);
        self.$element.find('.form-select-wrapper-registration').selectize();
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-info-member.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  }
};

RegistrationInfoMember.prototype.setStudentLocations = function() {
  var self = this,
    url = self.API.getStudentLocations;

  if (self.studentLocations().length === 0) {
    APIHelper.get(
      url,
      function(data) {
        var defaultOption = [{ Key: -1, Value: 'Eksisterer ikke i listen' }];
        var newData = defaultOption.concat(data);
        self.studentLocations(newData);
        self.studentTraineeLocationId(self.studentLocationTmp);
        self.$element
          .find('.form-select-wrapper-student-locations')
          .selectize();
      },
      function(response) {
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-info-member.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  }
};

RegistrationInfoMember.prototype.setYearArray = function() {
  var self = this;
  var currentYear = new Date().getFullYear();
  var fiveYearsArr = [];

  for (var i = 0; i < 5; i++) {
    fiveYearsArr.push({
      key: currentYear + i + self.studentMonthAndDay,
      value: currentYear + i
    });
  }

  self.yearArray(fiveYearsArr);
  self.studentTraineeEndDate(self.studentTraineeEndDateTmp);
};

RegistrationInfoMember.prototype.triggerModal = function() {
  this.activeModal(!this.activeModal());
};

RegistrationInfoMember.prototype.closeModal = function() {
  this.activeModal(false);
};

RegistrationInfoMember.prototype.populateInputFromStore = function(store) {
  if (this.parent.signuptype !== 'studentandpractice') {
    this.isBureauMemberOfRn(store.isBureauMemberOfRn);
    this.positionLevel(parseInt(store.positionLevel, 10));
    this.positionLevelTmp = parseInt(store.positionLevel, 10);
    this.workTitle(store.workTitle);
    this.otherRoles(store.otherRoles);
    this.recruiter(store.recruiter);
  } else {
    this.isStudentOrTrainee(store.isStudentOrTrainee);
  }
};

RegistrationInfoMember.prototype.createStoreObject = function() {
  var retObj = null;
  if (this.parent.signuptype !== 'studentandpractice') {
    retObj = {
      isBureauMemberOfRn: this.isBureauMemberOfRn(),
      positionLevel: this.positionLevel(),
      workTitle: this.workTitle(),
      otherRoles: this.otherRoles(),
      recruiter: this.recruiter()
    };
  } else {
    retObj = {
      isStudentOrTrainee: this.isStudentOrTrainee(),
      studentTraineeLocation: this.studentTraineeLocation(),
      studentTraineeLocationId: this.studentTraineeLocationId(),
      studentTraineeEndDate: this.studentTraineeEndDate()
    };
  }
  // Store all the observable values into an object.
  return retObj;
};

RegistrationInfoMember.prototype.storeValues = function() {
  this.parent.storeValuesForStep('infoMember', this.createStoreObject());
};

RegistrationInfoMember.prototype.validateInputOnStep = function() {
  return this.parent.validateFields(this.requiredFields);
};

RegistrationInfoMember.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationInfoMember.prototype.nextStep = function() {
  // 1: Validate step. If successful, goto next step.
  if (!this.validateInputOnStep()) {
    var location = window.location.href || document.URL;
    APIHelper.post('/api/log/error', {
      message: 'NOT-VALIDATED: registration-info-member.js',
      context: location,
      parameters: [
        'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
        'platform: ' + navigator.platform
      ]
    });
    return;
  }

  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Allow to continue execution.

  // if (this.parent.signuptype === 'studentandpractice' && this.isStudentOrTrainee() === 'student') {
  // 	this.parent.nextStep(1);
  // }
  // else {
  this.parent.nextStep();
  // }
};

// Just used for testing.
RegistrationInfoMember.prototype.nextStepSkip = function() {};

module.exports = RegistrationInfoMember;
